export default __webpack_public_path__ + "a2ef48faae7be0e065702f6b942e6e88.png";